<div style="position:fixed;top: 0;bottom: 0;left: 0; right: 0;background:rgba(0, 0, 0, .4);width:100%; height: 100%; z-index:1" *ngIf="appLoader">
  <div style="position:absolute;left: calc(50% - 50px);top: calc(50% - 50px);">
    <mat-spinner></mat-spinner>
  </div>
</div>
<router-outlet></router-outlet>
